import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DocumentsService } from 'src/app/services/documents.service';
import { Subject } from '../../shared/model/subject.model';

@Component({
    selector: 'app-subject-selector-modal',
    templateUrl: './subject-selector-modal.component.html',
    styleUrls: ['../documents.component.scss'],
    standalone: false
})
export class SubjectSelectorModalComponent implements OnInit {

  title: string

  materias: Subject[]
  selectedMateria: Subject
  submaterias: Subject[]
  selectedSubmateria: Subject
  statusModal = false
  previousSelection: Subject
  emptyButton: string

  parentid: number 
  subjectid: number

  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  constructor(
    public activeModal: NgbActiveModal,
    public documentsService: DocumentsService
  ) { }

  ngOnInit() {
    this.documentsService.getSubjects().subscribe( async response => {
      this.materias = response['result']
      if (this.previousSelection) {
        if (this.previousSelection.parentid) {
          this.selectedMateria = this.materias.find(m => m.id == this.previousSelection.parentid)
          await this.getSubmaterias(this.selectedMateria)
          this.selectedSubmateria = this.submaterias.find(s => s.id == this.previousSelection.id)
        } else {
          this.selectedMateria = this.materias.find(m => m.id == this.previousSelection.id)
          this.getSubmaterias(this.selectedMateria)
        }
      }
      if (this.parentid && this.subjectid) {
        this.selectedMateria = this.materias.find(m => m.id == this.parentid)
        await this.getSubmaterias(this.selectedMateria)
        this.selectedSubmateria = this.submaterias.find(s => s.id == this.subjectid)
      }
    })
  }

  async getSubmaterias(materia: Subject) {
    this.selectedSubmateria = null
    if (!materia.id) {
      this.submaterias = []
    } else {
      const response = await this.documentsService.getSubjects(String(materia.id)).toPromise()
      this.submaterias = response['result']
    }
  }

  confirm(typeListSubject) {
    const data = {subject: this.selectedSubmateria, parent: this.selectedMateria, ok:true, all: typeListSubject}
    this.passEntry.emit(data);
  }

}
